import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFound = ({ title, buttonLabel, onClick }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <Search size={48} color="var(--gray-graphite)" />
      <p className="text-xl">{title}</p>
      {onClick && (
        <Button size="sm" variant="outline" onClick={onClick}>
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default NotFound;
